import AccordionComp from 'components/accordion/Accordion'
import Button from 'components/formElements/Button'
import DefaultSelect from 'components/formElements/DefaultSelect'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import moment from 'moment'
import {Calendar} from 'primereact/calendar'
import {Column} from 'primereact/column'
import {DataTable} from 'primereact/datatable'
import {useState, useEffect} from 'react'
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import Loading from 'components/loader/Loading'
import { useParams } from 'react-router-dom'
const ProjectReport = () => {
	const { projectId } = useParams()
	const [getProjects] = useRequest()
	const [getReport, getReportLoading] = useRequest()
	const [projects, setProjects] = useState()
	const { showToast } = useToast()
	const [report, setReport] = useState({
		budgetSummaries: [],
		devSummaries: [],
		workTypeSummaries: [],
	})
	const [requestBody, setRequestBody] = useState({
		startDate: moment().subtract(1, 'months').toISOString(),
		endDate: moment().toISOString(),
		projectId: null,
	})
	useEffect(() => {
		getProjects('/Project/GetAllProjects', { method: 'GET', params: { isArchive: false } }).then((res) => {
			if (res.data.ok) {
				setProjects(
					res.data.result
						?.sort(function (a, b) {
							return a.customerName.localeCompare(b.customerName)
						})
						?.map((p) => ({ label: p.customerName + '-' + p.name, value: p.id }))
				)
			}
		})
		if (projectId) {
			setRequestBody((prev) => ({ ...prev, projectId: projectId }))
		}
	}, [])
	const handleChange = (e) => {
		console.log(e)
		setRequestBody((prev) => ({ ...prev, [e.name]: e.value }))
	}
	const handleSubmit = () => {
		if (!requestBody.endDate || !requestBody.startDate || !requestBody.projectId) {
			showToast('Lütfen Tüm Alanları Doldurun', 'error')
		} else {
			getReport('/Tempo/Report1', {
				method: 'POST',
				data: requestBody,
			}).then((res) => {
				if (res.data.ok) {
					setReport(res.data.result)
				}
			})
		}
	}
	return (
		<AnimatedSpan className='page-container d-flex flex-column gap-4'>
			<div className='card'>
				<div className='row-margin-x'>
					<div className='col-md-8'>
						<div className='row'>
							<div className='col-md-3'>
								<Calendar
									dateFormat='dd/mm/yy'
									placeholder='Başlangıç Tarihi'
									value={requestBody.startDate && new Date(requestBody.startDate)}
									name='startDate'
									onChange={(e) => {
										handleChange({ name: e.target.name, value: moment(e.target.value).add(3, 'hours').toISOString() })
									}}
								/>
							</div>
							<div className='col-md-3'>
								<Calendar
									dateFormat='dd/mm/yy'
									placeholder='Bitiş Tarihi'
									value={requestBody.endDate && new Date(requestBody.endDate)}
									name='endDate'
									onChange={(e) => {
										handleChange({ name: e.target.name, value: moment(e.target.value).add(3, 'hours').toISOString() })
									}}
								/>
							</div>
							<div className='col-md-6'>
								<DefaultSelect
									isSearchable
									placeholder='Proje Seçiniz'
									value={projects?.find((p) => p.value == requestBody.projectId) && projects?.find((p) => p.value == requestBody.projectId)}
									selectOptions={projects}
									handleChange={(e) => handleChange({ name: 'projectId', value: e.value })}
								/>
							</div>
						</div>
					</div>
					<div className='col-md-2'>
						<Button
							disabled={getReportLoading}
							title='Raporu Al'
							handleClick={handleSubmit}
							className='btn-primary w-100 d-flex justify-content-center'
						/>
					</div>
				</div>
			</div>
			{report.devSummaries.length == 0 && report.workTypeSummaries.length == 0 && report.budgetSummaries.length == 0 && !getReportLoading && (
				<div className='card'>
					<div className='text-sm text-semi-bold'>Gösterilecek Bir Veri Bulunmuyor</div>
				</div>
			)}
			{getReportLoading && (
				<div className='d-flex w-100 justify-content-center'>
					<Loading size={24} />
				</div>
			)}
			<div className='row'>
			{report.devSummaries.length > 0 && (
				<AccordionComp className='report-accordion col-md-4' showHideTitle={false} onVal={false} title='Kaynak Eforları'>
					<div className='row-margin-x'>
						<div className='col-md-12'>
							<DataTable
								emptyMessage='Hiç Kayıt Bulunamadı'
								responsiveLayout='stack'
								editMode='row'
								dataKey='id'
								stripedRows
								value={report.devSummaries.sort((a,b) => a.developer.localeCompare(b.developer))}
								footerColumnGroup={
									<ColumnGroup>
										<Row>
											<Column footer='Total:' />
											<Column
												footer={() => (
													<span>
														{Math.round(
															report?.devSummaries?.reduce((accumulator, object) => {
																return accumulator + object.spentHours
															}, 0) * 100
														) / 100}
														h
													</span>
												)}
											/>
										</Row>
									</ColumnGroup>
								}
								sortField='developer' // Developer alanına göre sıralama yapılıyor
								sortOrder={1} // Artan sıralama için 1, azalan sıralama için -1
							>
								<Column
									sortable
									className='text-semi-bold text-sm'
									headerClassName='text-bold bg-primary text-default'
									field='developer'
									style={{ width: '33%' }}
									header='Developer'
								/>
								<Column
									sortable
									className='text-semi-bold text-sm'
									headerClassName='text-bold bg-primary text-default'
									field='spentHours'
									style={{ width: 'auto' }}
									header='Efor'
									body={(rowData) => <span>{Math.round(rowData.spentHours * 100) / 100}h</span>}
								/>
							</DataTable>
						</div>
					</div>
				</AccordionComp>
			)}
			{report.workTypeSummaries.length > 0 && (
				<AccordionComp className='report-accordion col-md-4' showHideTitle={false} onVal={false} title='Work type Eforları'>
					<div className='row-margin-x'>
						<div className='col-md-12'>
							<DataTable
								emptyMessage='Hiç Kayıt Bulunamadı'
								responsiveLayout='stack'
								editMode='row'
								dataKey='id'
								stripedRows
								value={report.workTypeSummaries}
								footerColumnGroup={
									<ColumnGroup>
										<Row>
											<Column footer='Total:' />
											<Column
												footer={() => (
													<span>
														{Math.round(
															report?.workTypeSummaries?.reduce((accumulator, object) => {
																return accumulator + object.spentHours
															}, 0) * 100
														) / 100}
														h
													</span>
												)}
											/>
										</Row>
									</ColumnGroup>
								}
								sortField="workType" sortOrder="1"
							>
								<Column
									sortable
									className='text-semi-bold text-sm'
									headerClassName='text-bold bg-primary text-default'
									field='workType'
									style={{ width: '33%' }}
									header='Work Type'
								/>
								<Column
									sortable
									className='text-semi-bold text-sm'
									headerClassName='text-bold bg-primary text-default'
									field='spentHours'
									style={{ width: 'auto' }}
									header='Efor'
									body={(rowData) => <span>{Math.round(rowData.spentHours * 100) / 100}h</span>}
								/>
							</DataTable>
						</div>
					</div>
				</AccordionComp>
			)}
			{report.budgetSummaries.length > 0 && (
				<AccordionComp
					className='report-accordion col-md-4'
					showHideTitle={false}
					onVal={false}
					title={requestBody.endDate && `${moment(requestBody.endDate).format('ll')} Tarihi Öncesi Son 6 Ay Harcanan Bütçe`}
				>
					<div className='row-margin-x'>
						<div className='col-md-12'>
							<DataTable emptyMessage='Hiç Kayıt Bulunamadı' responsiveLayout='stack' stripedRows editMode='row' dataKey='id' value={report.budgetSummaries}>
								<Column
									sortable
									className='text-semi-bold text-sm'
									headerClassName='text-bold bg-primary text-default'
									field='month'
									style={{ width: '33%' }}
									header='Ay'
								/>
								<Column
									sortable
									className='text-semi-bold text-sm'
									headerClassName='text-bold bg-primary text-default'
									field='total'
									style={{ width: 'auto' }}
									header='Bütçe'
									body={(rowData) => (
										<span>
											{rowData.total} {rowData.currency}
										</span>
									)}
								/>
							</DataTable>
						</div>
					</div>
				</AccordionComp>
			)}
			</div>
			
		</AnimatedSpan>
	)
}

export default ProjectReport

